/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Image_Models_InfoInputs */



/**
* | output |
* | --- |
* | "Image models enabled for the whole organization are always available to every team. Use this to give this team additional image models." |
*
* @param {Team_Image_Models_InfoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const team_image_models_info = /** @type {((inputs?: Team_Image_Models_InfoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Image_Models_InfoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bildmodelle, die für die ganze Organisation freigegeben sind, stehen allen Teams immer zur Verfügung. Hier weisen Sie diesem Team zusätzliche Bildmodelle zu.")
	return /** @type {LocalizedString} */ ("Image models enabled for the whole organization are always available to every team. Use this to give this team additional image models.")
});